<div class="d-flex rankers">
    <img [src]="'assets/images/virtusa-icons/' + (rank >= 1 ? (isError ? 'star-error' : 'star-green') : 'star') + '.png'">
    <img [src]="'assets/images/virtusa-icons/' + (rank >= 2 ? (isError ? 'star-error' : 'star-green') : 'star') + '.png'">
    <img [src]="'assets/images/virtusa-icons/' + (rank >= 3 ? (isError ? 'star-error' : 'star-green') : 'star') + '.png'">
    <img [src]="'assets/images/virtusa-icons/' + (rank >= 4 ? (isError ? 'star-error' : 'star-green') : 'star') + '.png'">
    <img [src]="'assets/images/virtusa-icons/' + (rank >= 5 ? (isError ? 'star-error' : 'star-green') : 'star') + '.png'">
</div>
